import React from 'react'
import colors from '../../utils/colors'

const Radio = ({name, id, label, onChange, className, disabled, value, checked}) => {
  const outStyle = {
    width: '20px',
    height: '20px',
    borderColor: '#ddd',
  }

  const innerStyle = {
    width: '12px',
    height: '12px',
    background: checked ? colors.green : '#fff'
  }

  return (
    <label className={`cursor-pointer flex lg:items-center ${className}`} htmlFor={id}>
      <div>
        <input
          type="radio"
          name={name}
          value={value}
          id={id}
          className="hidden"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <div
          style={outStyle}
          className="rounded-full mr-2 border flex justify-center items-center"
        >
          <div style={innerStyle} className="rounded-full"></div>
        </div>
      </div>
      <div className="leading-none lg:leading-normal">
        <span
          className={`leading-none lg:leading-normal text-sm text-gray-444 ${
            disabled ? "opacity-50" : ""
          }`}
        >
          {label}
        </span>
      </div>
    </label>
  );
}

export { Radio }
